import ReactDOM from "react-dom/client";
import App from "./app";
import "@core/styles/global.scss";
import { Provider } from "react-redux";
import store from "@app/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Environment } from "@environments/environment";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={Environment.GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      <App />
    </Provider>
  </GoogleOAuthProvider>
  // </React.StrictMode>
);
